import * as React from 'react'

import { Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'
import { Product } from 'even-ts-static'
import Wrapper from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onContinue: () => void
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepPropertyStatus: React.SFC<Props> = (props) => (
  <Wrapper {...props}>
    <StepTitle>Do you rent or own your home?</StepTitle>
    <ApplicationField
      onChange={props.handleChangeAndContinue.bind(null, Fields.PropertyStatusButtonList)}
      product={Product.Loan}
      field={Fields.PropertyStatusButtonList}
    />
  </Wrapper>
)

export default StepbystepApplicationStepPropertyStatus
